import { getToken, getTokenAud } from '@sit/client-shared';
import { config } from '@web/config/env';
import { logout } from '@web/redux/authentication-slice';
import { useAppDispatch } from '@web/redux/store';
import { useEffect } from 'react';

export function useForceLogoutSITWeb() {
  const dispatch = useAppDispatch();
  const token = getToken();
  const aud = getTokenAud(token);
  useEffect(() => {
    if (aud === 'sit' && !config.loginEnabled) {
      // Standalone SIT web in production doesn't allow login, so we force logout.
      dispatch(logout());
    }
  }, [aud]);
}
